import { render, staticRenderFns } from "./Template_2.vue?vue&type=template&id=5d330052&scoped=true"
import script from "./Template_2.vue?vue&type=script&lang=js"
export * from "./Template_2.vue?vue&type=script&lang=js"
import style0 from "./Template_2.vue?vue&type=style&index=0&id=5d330052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d330052",
  null
  
)

export default component.exports